import { render, staticRenderFns } from "./SetupMicrophone.vue?vue&type=template&id=6fa5c2ae"
import script from "./SetupMicrophone.vue?vue&type=script&lang=js"
export * from "./SetupMicrophone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports